import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header header--mobile header--internal header--ios" }
const _hoisted_2 = { class: "header__inner" }
const _hoisted_3 = { class: "header__title-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "header__title"
}
const _hoisted_5 = { class: "header__actions" }

import { computed } from 'vue'

import type { DocView } from '@/models/doc'
import { auth } from '@/services/auth'

import BackLink from '@/app/components/BackLink.vue'
import StartFreeTrialButton from '@/app/components/header/StartFreeTrialButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Internal',
  props: {
    title: {},
    backLinkDoc: {}
  },
  setup(__props: any) {



const isFreePlan = computed(() => auth.isFreePlan())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BackLink, { class: "header__backlink" }),
      _createElementVNode("div", _hoisted_3, [
        (__props.title)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(__props.title), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "actions"),
        (isFreePlan.value)
          ? (_openBlock(), _createBlock(StartFreeTrialButton, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})